import script from "./JobDetailsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetailsDialog.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./JobDetailsDialog.vue?vue&type=style&index=1&id=b0b8a9aa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/employer/employer/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b0b8a9aa"]])

export default __exports__